
import Vue from 'vue';
import Component from 'vue-class-component';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import SearchVideos from '@/app/components/SearchVideos.vue';
import TRadio from '@/lib/form/radio/Radio.vue';

@Component({
  name: 'list-view',
  props: [
    'folderId',
    'toBeExcluded',
    'selectedVideos',
    'loadedFolders',
    'loadedVideos',
    'single-select',
    'loadingVideos',
    'v2Only',
  ],
  components: {
    TCheckbox,
    TRadio,
    TButton,
    SearchVideos,
  },
})
export default class ListView extends Vue {
  private loading = false;
  private videos: any[] = [];
  private searchVideos: any[] = [];
  private folders: any[] = [];
  private selectedFolders: any[] = [];
  private folderId;
  private toBeExcluded;
  private selectedVideos;
  private loadedFolders;
  private loadedVideos;
  private noResult = false;
  private loadingVideos;
  private v2Only;

  mounted() {
    this.fetchFolderData();
    this.$root.$on('search-videos-results', this.updateSearchResults);
    this.$root.$on('search-empty', this.clearSearchResults);
    this.$root.$on('no-search-result', this.noSearchResult);
    this.selectedFolders.push({
      id: this.folderId,
      title: this.$t('home.select_video.sub_title'),
    });
  }
  updateSearchResults(videos) {
    this.searchVideos = videos;
  }

  clearSearchResults() {
    this.searchVideos = [];
    this.fetchFolderData();
  }

  noSearchResult(result: boolean) {
    this.noResult = result;
  }

  async fetchFolderData(openFolderId?) {
    const folderId = openFolderId || this.folderId;
    try {
      this.loading = true;
      if (
        Object.keys(this.loadedFolders).length == 0 ||
        this.loadedFolders[folderId] == undefined
      ) {
        const { data, meta } = await this.getFolders(folderId);
        this.videos = await this.getVideos(folderId);
        if (!this.v2Only) {
          this.videos = this.videos.filter((v) => v.state == 'active');
        } else {
          this.videos = this.videos.filter((v) => v.state != 'processing');
        }
        this.folders = data;
        this.$root.$emit(
          'update-loaded-folders',
          folderId,
          this.folders,
          this.videos
        );
      } else {
        this.$root.$emit('update-loaded-folders', folderId);
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$error(error);
    }
  }

  async getFolders(id) {
    return apiClient.getFolders(id);
  }

  async getVideos(id) {
    return apiClient.getVideos(id, 0, 100, this.v2Only);
  }

  isDisabled(video) {
    return (this.toBeExcluded || []).indexOf(video.id || video.uuid) != -1;
  }

  isSelected(video) {
    return (
      this.isDisabled(video) ||
      (this.selectedVideos || []).indexOf(video.id || video.uuid) != -1
    );
  }
  isLoading(id) {
    return this.loadingVideos && this.loadingVideos.includes(id);
  }

  update(checked, value) {
    this.$emit('update', checked, value);
  }

  updateVideo(value) {
    this.$emit('update', true, value);
  }

  updateVideos(checked, value, name) {
    this.$emit('update', checked, value, name);
  }

  handleFolder(id, title, e) {
    e.stopPropagation();
    if (!this.loading) {
      this.fetchFolderData(id);
      const index = this.selectedFolders.findIndex((folder) => folder.id == id);
      if (index == -1) {
        this.selectedFolders.push({ id, title });
        return;
      }
      this.selectedFolders = this.selectedFolders.splice(0, index + 1);
    }
  }

  addVideo(value) {
    this.updateVideo(value);
    this.$emit('add');
  }
}
